import { CLEAR_DATA_FORGOT_PASSWORD, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_REQUEST_ERROR, FORGOT_PASSWORD_REQUEST_SUCCESS, REDIRECT_PAGE_FROM_FORGOT_PASSWORD } from './Constants';

export const forgotPasswordRequest = (payload) => ({
    type: FORGOT_PASSWORD_REQUEST,
    payload : payload
});
export const forgotPasswordRequestSuccess = (msg) => ({
    type: FORGOT_PASSWORD_REQUEST_SUCCESS,
    msg : msg
});
export const forgotPasswordRequestError = () => ({
    type: FORGOT_PASSWORD_REQUEST_ERROR,
});

export const forgotPasswordpageRedirect = (url) => ({
    type: REDIRECT_PAGE_FROM_FORGOT_PASSWORD,
    url : url
});

export const clearDataReguest = () => ({
    type : CLEAR_DATA_FORGOT_PASSWORD
});